import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';

interface IState {
  memberStateExcludeCyprusList: any;
  ReimbursementsReceivedList: {
    status: StateStatus | null;
    data: any;
  };
  unreadNotificationCount: {
    status: StateStatus | null;
    data: number;
  };
}

const initialState: IState = {
  memberStateExcludeCyprusList: {
    status: null,
    data: null,
  },
  ReimbursementsReceivedList: {
    status: null,
    data: null,
  },
  unreadNotificationCount: {
    status: null,
    data: 0,
  },
};

const ReimbursementsReceivedListReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS:
      return {
        ...state,
        memberStateExcludeCyprusList: {
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_REIMBURSEMENT_RECEIVED_LIST:
      return {
        ...state,
        ReimbursementsReceivedList: {
          ...state.ReimbursementsReceivedList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.ReimbursementsReceivedList.data
              : action.data,
        },
      };
    case Types.SET_UNREAD_NOTIFICATION_COUNT:
      return {
        ...state,
        unreadNotificationCount: {
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.unreadNotificationCount.data
              : action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default ReimbursementsReceivedListReducer;

/**
 * Add new Page Steps:
 *
 * navigation -> config -> index.tsx
 * navigation -> config -> Routes.tsx
 *
 */
